import React, { createContext, useState } from 'react';

export const BreadcrumbContext = createContext();

export const BreadcrumbProvider = ({ children }) => {
    const [breadcrumbs, setBreadcrumbs] = useState([]);

    const addBreadcrumb = (breadcrumb) => {
        setBreadcrumbs((prevBreadcrumbs) => {
            // Check if breadcrumb already exists to prevent duplicates
            const exists = prevBreadcrumbs.some(b => b.path === breadcrumb.path);
            if (exists) {
                return prevBreadcrumbs;
            } else {
                // Add the new breadcrumb, ensuring the total length doesn't exceed 5
                const updatedBreadcrumbs = [...prevBreadcrumbs, breadcrumb];
                // If the length is over 5, remove the oldest breadcrumb(s)
                if (updatedBreadcrumbs.length > 5) {
                    return updatedBreadcrumbs.slice(-5); // Keep the last 5 items
                }
                return updatedBreadcrumbs;
            }
        });
    };

    const removeBreadcrumb = (path) => {
        setBreadcrumbs((prevBreadcrumbs) => prevBreadcrumbs.filter(b => b.path !== path));
    };

    return (
        <BreadcrumbContext.Provider value={{ breadcrumbs, addBreadcrumb, removeBreadcrumb }}>
            {children}
        </BreadcrumbContext.Provider>
    );
};
